import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, Card, Carousel } from 'react-bootstrap';
import img1 from '../../Resources/image 1.png';
import img2 from '../../Resources/Graphic 2.png';
import img3 from '../../Resources/Graphic 3.png';
import img4 from '../../Resources/Graphic 4.png';
import logo from '../../Resources/logo.svg';
import adminImg from '../../Resources/adminImg.png';
import './Login.css';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../utils/axiosInstance';

const Login = ({ handleLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Check on initial render
        handleResize();

        // Add event listener to track window resize
        window.addEventListener('resize', handleResize);

        // Clean up the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const isEmail = (value) => {
        const emailRegex = /\S+@\S+\.\S+/;
        return emailRegex.test(value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleLoginSubmit = async (event) => {
        event.preventDefault();

        if (!username) {
            toast.error('Username not provided');
            return;
        }

        if (!password) {
            toast.error('Password not provided');
            return;
        }

        if (!isEmail(username)) {
            toast.error('Please enter a valid email address');
            return;
        }

        setIsLoading(true);

        try {
            const response = await axiosInstance.post('/user/adminLogin', { email: username, password });
            const { accessToken, refreshToken, user } = response.data;

            // Storing tokens and user data in localStorage
            localStorage.setItem('token', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('loggedInEmployee', JSON.stringify(user));
            // console.log("user id -", user.emp_id)
            // console.log("company id -", user.company_id)
            localStorage.setItem('loggedInEmployeeId', user.emp_id);
            localStorage.setItem('companyId', user.company_id);
            localStorage.setItem('empRole', user.emp_role);
            handleLogin(accessToken, refreshToken, user);
            toast.success(t('Login successful'));
        } catch (error) {
            // Check if error response is available
            if (!error.response) {
                // Network error or no response
                toast.error("Looks like you are offline. Please check your internet connectivity.");
            } else {
                // Other errors
                toast.error(t('Invalid username or password!'));
                // console.error('Login error:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='login-Body'>
            {/* {isMobile && (
                <div className="mobile-view-message">
                    <h3>Welcome to HANSA-FLEX</h3>
                    <p>Website under construction !!!</p>
                    <hr />
                    <p>The mobile view of the website is under construction. Please switch to a laptop or PC to log in!</p>
                </div>
            )}
            {!isMobile && (
                <> */}
            <div className='background-page'></div>
            <Row>
                <Col md={6} className='d-flex flex-column'>
                    <div className='login-Body-logo'>
                        <img className='pb-5' src={logo} alt='' width={300} />
                    </div>
                    <div className='login-card-body'>
                        <Card className='login-card'>
                            <div className='login-card-person-img'>
                                {/* <img src={adminImg} alt='' /> */}
                                <svg width="40" height="40" fill="#d4021d" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M 7,7 C 8.6570312,7 10,5.65703 10,4 10,2.34297 8.6570312,1 7,1 5.3429688,1 4,2.34297 4,4 4,5.65703 5.3429688,7 7,7 Z M 9.2453125,7.76406 8.125,12.25 7.375,9.0625 8.125,7.75 5.875,7.75 6.625,9.0625 5.875,12.25 4.7546875,7.76406 C 3.0835937,7.84375 1.75,9.21016 1.75,10.9 l 0,0.975 C 1.75,12.49609 2.2539063,13 2.875,13 l 8.25,0 c 0.621094,0 1.125,-0.50391 1.125,-1.125 l 0,-0.975 c 0,-1.68984 -1.333594,-3.05625 -3.0046875,-3.13594 z" /></svg>
                            </div>
                            <form onSubmit={handleLoginSubmit}>
                                <div>
                                    <div className='form-group'>
                                        <input
                                            type='text'
                                            className='form-control'
                                            placeholder='Username'
                                            value={username}
                                            onChange={handleUsernameChange}
                                        />
                                        {username && !isEmail(username) && <p>{t('invalid_email')}</p>}
                                    </div>
                                    <div className='form-group'>
                                        <input
                                            type='password'
                                            className='form-control'
                                            placeholder='Password'
                                            value={password}
                                            onChange={handlePasswordChange}
                                        />
                                    </div>
                                </div>
                                <div>
                                    {isLoading ? (
                                        <div className='d-flex justify-content-center'>
                                            <div className='loading-bar' disabled>
                                                <span
                                                    className='spinner-border spinner-border-sm'
                                                    role='status'
                                                    aria-hidden='true'
                                                ></span>
                                                {/* Loading... */}
                                            </div>
                                        </div>
                                    ) : (
                                        <button type='submit' className='login-form-submit-button'>
                                            Sign in
                                        </button>
                                    )}
                                </div>
                                <div className='forgot-password'>
                                    <div className='forgot-password-checkbox'>{/* <input type="checkbox" /> */}</div>
                                    <div className='forgot-pass'></div>
                                </div>
                            </form>
                        </Card>
                    </div>
                </Col>
                <Col md={6} className='bg-white carousel-col-wrapper'>
                    <Carousel fade className='carousel-login'>
                        <Carousel.Item className='login-images-carousel-wrapper'>
                            <img className='login-images-carousel-image' src={img1} alt='First slide' />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='login-images-carousel-image' src={img2} alt='Second slide' />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='login-images-carousel-image' src={img3} alt='Second slide' />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img className='login-images-carousel-image' src={img4} alt='Second slide' />
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
            {/* </>
            )} */}
        </div>
    );
};

export default Login;
